import React, { useState, useEffect, useRef } from "react";
import './index.scss'

interface AiTabsProps {
    activeId?:number
    tabsData?:Array<any>
    background?:string
    _style?:any
    bg?:string
    onChange?:(index, item) => void
}

const AiTabs: React.FC<AiTabsProps> = ({tabsData = [], _style = {}, bg = '#F6F7F8', background = '#fff', ...props}) => {
    const tabsEl = useRef<any>(null)
    const [ activeId, setActiveId ] =  useState(props?.activeId || 0)
    const [ statusHeight, setStatusHeight ] =  useState<any>(localStorage.getItem('statusHeight') || 0)
    const handleChangeItem = (index, item, e) => {
        let offsetLeft = e.target.offsetLeft
        const offsetWidth = tabsEl.current.offsetWidth
        const left = offsetLeft - (offsetWidth / 2)
        tabsEl.current.scrollLeft = left
        setActiveId(index)
        if(props?.onChange) {
            props.onChange(index,item)
        }
    }
    useEffect(() => {
        setActiveId(props?.activeId || 0)
    }, [props.activeId])
    return <div className="smart-tabs-wrapper" style={{'--bg':bg}} ref={tabsEl}>
        {tabsData.map((item, index) => (
            <div className={`outside-circle ${activeId === index ? 'active' : ''}`} style={{'--background':background,..._style}} key={index} onClick={e => handleChangeItem(index,item, e)}>{item}</div>
        ))}
    </div>
}

export default AiTabs